(function () {
  var panelCounter = 0;
  function normalize(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  }
  function timestamp(value) {
    value = String(value || '');
    var result = /^\d{4}-\d{2}-\d{2}(?:T.*)?$/.test(value) ? Date.parse(value) : NaN;
    return Number.isFinite(result) ? result : null;
  }
  function earliest(previous, value) {
    var date = timestamp(value);
    return date === null ? previous : (previous === null ? date : Math.min(previous, date));
  }
  function collect(data, series) {
    data.products.forEach(function (product) {
      var key = normalize(product.era);
      if (!key) return;
      if (!series.has(key)) series.set(key, {name: product.era, date: null, expansions: new Map()});
      var era = series.get(key);
      era.date = earliest(era.date, product.date);
      var expansionKey = normalize(product.expansion);
      if (!expansionKey) return;
      if (!era.expansions.has(expansionKey)) era.expansions.set(expansionKey, {name: product.expansion, date: null});
      var expansion = era.expansions.get(expansionKey);
      expansion.date = earliest(expansion.date, product.expansionDate);
    });
  }
  function newest(a, b) {
    var dateA = a.date === null ? -Infinity : a.date;
    var dateB = b.date === null ? -Infinity : b.date;
    return dateA === dateB ? a.name.localeCompare(b.name) : (dateA > dateB ? -1 : 1);
  }
  function seriesOrder(a, b) {
    var lastA = normalize(a.name) === 'pokemon tcg';
    var lastB = normalize(b.name) === 'pokemon tcg';
    return lastA !== lastB ? (lastA ? 1 : -1) : newest(a, b);
  }
  function expansionLink(data, era, expansion) {
    var url = new URL(data.collection, window.location.origin);
    url.searchParams.set(data.eraParam, era);
    url.searchParams.set(data.expansionParam, expansion);
    return url.pathname + url.search;
  }
  function collectExpansions(data, expansions) {
    data.products.forEach(function (product) {
      var key = normalize(product.expansion);
      if (!key) return;
      var grouped = normalize(product.era) === 'pokemon tcg';
      // Keep separate entries when an expansion name occurs in both kinds of series.
      key = (grouped ? 'tcg:' : 'regular:') + key;
      if (!expansions.has(key)) expansions.set(key, {
        name: product.expansion, date: null, grouped: grouped, era: product.era
      });
      var expansion = expansions.get(key);
      expansion.date = earliest(expansion.date, product.expansionDate);
    });
  }
  function renderExpansions(menu, data, expansions) {
    if (!menu || !expansions.size) return;
    var entries = new Map();
    var group = {name: 'Pokemon TCG', date: null, expansions: new Map()};
    expansions.forEach(function (expansion, key) {
      if (expansion.grouped) {
        group.expansions.set(key, expansion);
        group.era = expansion.era;
        return;
      }
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.textContent = expansion.name;
      var url = new URL(data.collection, window.location.origin);
      url.searchParams.set(data.expansionParam, expansion.name);
      link.href = url.pathname + url.search;
      item.appendChild(link);
      entries.set(key, {name: expansion.name, date: expansion.date, expansions: new Map(), element: item});
    });
    if (group.expansions.size) {
      // Preserve the exact Era value in links even if the label has accents/case differences.
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.textContent = group.name;
      var url = new URL(data.collection, window.location.origin);
      url.searchParams.set(data.eraParam, group.era);
      link.href = url.pathname + url.search;
      item.appendChild(link);
      group.element = item;
      entries.set('tcg-group', group);
    }
    menu.replaceChildren();
    render(menu, data, entries);
  }
  function render(menu, data, series) {
    // Preserve existing series links, then add entries missing from the filter fallback.
    Array.from(menu.children).filter(function (item) { return item.tagName === 'LI'; }).forEach(function (item) {
      var anchor = item.querySelector('a');
      if (!anchor) return;
      var name = anchor.textContent.trim();
      var key = normalize(name);
      if (!series.has(key)) series.set(key, {name: name, date: null, expansions: new Map()});
      series.get(key).element = item;
    });
    var ordered = Array.from(series.values()).sort(seriesOrder);
    ordered.forEach(function (era, index) {
      var item = era.element;
      if (!item) {
        item = document.createElement('li');
        var anchor = document.createElement('a');
        anchor.textContent = era.name;
        var url = new URL(data.collection, window.location.origin);
        url.searchParams.set(data.eraParam, era.name);
        anchor.href = url.pathname + url.search;
        item.appendChild(anchor);
        era.element = item;
      }
      var expansions = Array.from(era.expansions.values()).sort(newest);
      if (expansions.length) {
        item.classList.add('has-submenu', 'series-item');
        var button = item.querySelector('[data-series-toggle]');
        var panel = item.querySelector('[data-series-expansions]');
        if (!button) {
          button = document.createElement('button');
          button.type = 'button';
          button.dataset.seriesToggle = '';
          button.dataset.submenuToggle = '';
          button.setAttribute('aria-expanded', 'false');
          button.setAttribute('aria-label', 'Expansiones de ' + era.name);
          button.textContent = '›';
          panel = document.createElement('ul');
          panel.className = 'submenu series-expansions';
          panel.id = menu.id + '-expansions-' + (++panelCounter);
          panel.dataset.submenuPanel = '';
          panel.dataset.seriesExpansions = '';
          button.setAttribute('aria-controls', panel.id);
          item.appendChild(button);
          item.appendChild(panel);
        }
        panel.replaceChildren();
        expansions.forEach(function (expansion) {
          var entry = document.createElement('li');
          var link = document.createElement('a');
          link.textContent = expansion.name;
          link.href = expansionLink(data, expansion.era || era.name, expansion.name);
          entry.appendChild(link);
          panel.appendChild(entry);
        });
      }
      menu.appendChild(item);
    });
  }
  function values(value) {
    return (Array.isArray(value) ? value : [value]).filter(function (entry) {
      return typeof entry === 'string' && entry.trim();
    });
  }
  function collectTypes(data, types) {
    data.products.forEach(function (product) {
      values(product.type).forEach(function (name) {
        var key = normalize(name);
        if (!types.has(key)) types.set(key, {name: name, subtypes: new Map()});
        values(product.subtype).forEach(function (subtype) {
          types.get(key).subtypes.set(normalize(subtype), subtype);
        });
      });
    });
  }
  function typeLink(data, type, subtype) {
    var url = new URL(data.collection, window.location.origin);
    url.searchParams.set(data.typeParam, type);
    if (subtype) url.searchParams.set(data.subtypeParam, subtype);
    return url.pathname + url.search;
  }
  function renderTypes(menu, data, types, options) {
    options = options || {};
    if (!menu) return;
    menu.replaceChildren();
    if (!types.size) {
      var empty = document.createElement('li');
      var message = document.createElement('span');
      message.className = 'empty-menu';
      message.textContent = options.emptyText || 'Aún no hay tipos disponibles.';
      empty.appendChild(message);
      menu.appendChild(empty);
      return;
    }
    Array.from(types.values()).sort(options.order || function (a, b) { return a.name.localeCompare(b.name, 'es'); }).forEach(function (type) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.textContent = type.name;
      link.href = typeLink(data, type.name);
      item.appendChild(link);
      if (type.subtypes.size) {
        item.classList.add('has-submenu', 'series-item');
        var panel = document.createElement('ul');
        panel.className = 'submenu series-expansions';
        panel.id = menu.id + '-subtypes-' + (++panelCounter);
        panel.dataset.submenuPanel = '';
        var button = document.createElement('button');
        button.type = 'button';
        button.dataset.seriesToggle = '';
        button.dataset.submenuToggle = '';
        button.textContent = '›';
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', panel.id);
        button.setAttribute('aria-label', (options.childLabel || 'Subtipos') + ' de ' + type.name);
        Array.from(type.subtypes.values()).sort(function (a, b) { return a.localeCompare(b, 'es'); }).forEach(function (subtype) {
          var entry = document.createElement('li');
          var child = document.createElement('a');
          child.textContent = subtype;
          child.href = typeLink(data, type.name, subtype);
          entry.appendChild(child);
          panel.appendChild(entry);
        });
        item.appendChild(button);
        item.appendChild(panel);
      }
      menu.appendChild(item);
    });
  }
  function collectCatalogTypes(data, types) {
    data.products.forEach(function (product) {
      values(product.type).forEach(function (name) {
        var key = normalize(name);
        if (!types.has(key)) types.set(key, {name: name, licenses: new Map()});
        values(product.license).forEach(function (license) {
          var group = types.get(key).licenses;
          var licenseKey = normalize(license);
          if (!group.has(licenseKey)) group.set(licenseKey, {name: license, subtypes: new Map()});
          values(product.subtype).forEach(function (subtype) { group.get(licenseKey).subtypes.set(normalize(subtype), {name: subtype}); });
        });
      });
    });
  }
  function renderCatalogTypes(menu, data, types) {
    menu.replaceChildren();
    if (!types.size) {
      var empty = document.createElement('li'); empty.textContent = 'Aún no hay tipos disponibles.'; menu.appendChild(empty); return;
    }
    function entries(panel, groups, level, selected) {
      Array.from(groups.values()).sort(function (a, b) { return a.name.localeCompare(b.name, 'es'); }).forEach(function (group) {
        var choice = selected.slice(); choice[level] = group.name;
        var item = document.createElement('li'); item.className = 'series-item';
        var link = document.createElement('a'); link.textContent = group.name;
        var url = new URL(data.collection, window.location.origin);
        [data.typeParam, data.licenseParam, data.subtypeParam].forEach(function (param, index) { if (choice[index]) url.searchParams.set(param, choice[index]); });
        link.href = url.pathname + url.search; item.appendChild(link);
        var children = level === 0 ? group.licenses : (level === 1 ? group.subtypes : null);
        if (children && children.size) {
          item.classList.add('has-submenu');
          var childPanel = document.createElement('ul'); childPanel.className = 'submenu series-expansions';
          childPanel.id = menu.id + '-level-' + level + '-' + (++panelCounter); childPanel.dataset.submenuPanel = '';
          var button = document.createElement('button'); button.type = 'button'; button.textContent = '›';
          button.dataset.seriesToggle = ''; button.dataset.submenuToggle = '';
          button.setAttribute('aria-controls', childPanel.id); button.setAttribute('aria-expanded', 'false');
          button.setAttribute('aria-label', (level === 0 ? 'Licencias' : 'Subtipos') + ' de ' + group.name);
          entries(childPanel, children, level + 1, choice);
          item.appendChild(button); item.appendChild(childPanel);
        }
        panel.appendChild(item);
      });
    }
    entries(menu, types, 0, []);
  }
  function collectLicenses(data, groups, field) {
    data.products.forEach(function (product) {
      values(product[field]).forEach(function (name) {
        var key = normalize(name);
        if (!groups.has(key)) groups.set(key, {name: name, date: null, subtypes: new Map()});
        var group = groups.get(key);
        group.date = earliest(group.date, product.date);
        values(product.license).forEach(function (license) {
          group.subtypes.set(normalize(license), license);
        });
      });
    });
  }
  function collectArrivals(data, categories) {
    data.products.forEach(function (product) {
      values(product.category).forEach(function (name) {
        var key = normalize(name);
        var date = timestamp(product.expansionDate);
        if (!categories.has(key)) categories.set(key, {name: name, date: null});
        var category = categories.get(key);
        if (date !== null) category.date = category.date === null ? date : Math.max(category.date, date);
      });
    });
  }
  function renderArrivals(menu, data, categories) {
    menu.replaceChildren();
    Array.from(categories.values()).sort(newest).slice(0, 6).forEach(function (category) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      var url = new URL(data.collection, window.location.origin);
      url.searchParams.set(data.categoryParam, category.name);
      link.href = url.pathname + url.search;
      link.textContent = category.name;
      item.appendChild(link);
      menu.appendChild(item);
    });
    if (!categories.size) {
      var empty = document.createElement('li');
      empty.textContent = 'Aún no hay categorías disponibles.';
      menu.appendChild(empty);
    }
  }
  function renderTopps(menu, data, series, sports) {
    renderArrivals(menu, data, series);
    renderTypes(document.getElementById('topps-sports'), Object.assign({}, data, {typeParam: data.sportParam, subtypeParam: data.licenseParam}), sports,
      {childLabel: 'Licencias', emptyText: 'Aún no hay deportes disponibles.'});
  }
  function pokemonSealedData(data) {
    var url = new URL(data.collection, window.location.origin);
    url.searchParams.set(data.licenseParam, 'Pokemon');
    url.searchParams.set(data.typeParam, 'Sellados');
    data.collection = url.pathname + url.search;
    data.products = data.products.filter(function (product) {
      return values(product.type).some(function (type) { return normalize(type) === 'sellados'; });
    });
    return data;
  }
  function renderPokemonSubtypes(menu, data, types) {
    if (!menu) return;
    menu.replaceChildren();
    var subtypes = new Map();
    types.forEach(function (type) { type.subtypes.forEach(function (name, key) { subtypes.set(key, name); }); });
    Array.from(subtypes.values()).sort(function (a, b) { return a.localeCompare(b, 'es'); }).forEach(function (name) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      var url = new URL(data.collection, window.location.origin);
      url.searchParams.set(data.subtypeParam, name);
      link.href = url.pathname + url.search;
      link.textContent = name;
      item.appendChild(link);
      menu.appendChild(item);
    });
    if (!subtypes.size) {
      var empty = document.createElement('li');
      empty.textContent = 'Aún no hay subtipos disponibles.';
      menu.appendChild(empty);
    }
  }
  async function initialize(menu) {
    var script = menu.querySelector('[data-series-dates]');
    if (!script) return;
    var series = new Map();
    var expansions = new Map();
    var types = new Map();
    var licensedSeries = new Map();
    var sports = new Map();
    var isTopps = menu.id === 'topps-series';
    var isPokemon = menu.id === 'pokemon-series';
    var typesOnly = menu.hasAttribute('data-types-only');
    var typesMenu = typesOnly ? menu : document.getElementById(menu.id.replace('-series', '-types'));
    try {
      var data = JSON.parse(script.textContent);
      if (isPokemon) pokemonSealedData(data);
      collect(data, series);
      collectExpansions(data, expansions);
      if (typesOnly) collectCatalogTypes(data, types); else collectTypes(data, types);
      if (typesOnly) renderCatalogTypes(typesMenu, data, types); else if (isPokemon || isTopps) renderPokemonSubtypes(typesMenu, data, types); else renderTypes(typesMenu, data, types);
      if (isTopps) {
        collectArrivals(data, licensedSeries);
        collectLicenses(data, sports, 'sport');
        renderTopps(menu, data, licensedSeries, sports);
      } else if (!typesOnly) render(menu, data, series);
      // Start from a clean collection page so active product filters cannot hide expansions.
      var page = 1;
      var visited = new Set();
      while (page && !visited.has(page)) {
        visited.add(page);
        var url = new URL(data.collection, window.location.origin);
        url.searchParams.set('section_id', 'header');
        var previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        url.searchParams.set('page', page);
        var response = await fetch(url.toString());
        if (!response.ok) throw new Error('Series data request failed');
        var documentPage = new DOMParser().parseFromString(await response.text(), 'text/html');
        var next = documentPage.getElementById(menu.id);
        var nextScript = next && next.querySelector('[data-series-dates]');
        if (!nextScript) throw new Error('Series data missing');
        data = JSON.parse(nextScript.textContent);
        if (isPokemon) pokemonSealedData(data);
        collect(data, series);
        collectExpansions(data, expansions);
        if (typesOnly) collectCatalogTypes(data, types); else collectTypes(data, types);
        if (isTopps) {
          collectArrivals(data, licensedSeries);
          collectLicenses(data, sports, 'sport');
        } else render(menu, data, series);
        page = data.nextPage;
      }
      if (isTopps) renderTopps(menu, data, licensedSeries, sports);
      else if (!typesOnly) renderExpansions(document.getElementById(menu.id.replace('-series', '-expansions')), data, expansions);
      if (typesOnly) renderCatalogTypes(typesMenu, data, types); else if (isPokemon || isTopps) renderPokemonSubtypes(typesMenu, data, types); else renderTypes(typesMenu, data, types);
    } catch (error) {
      console.warn('Stackerz: no se pudieron cargar todas las series y expansiones.', error);
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-sort-series]').forEach(initialize);
  });
}());

